import { useAppSelector } from 'core/store';

export const useActionPermission = (path: string) => {
  const actionsPermissionsData = useAppSelector((state) => state.userProfile.permissions);

  return Boolean(actionsPermissionsData?.[path]);
};
